import { render, staticRenderFns } from "./NotificationCardForMandalaEvaluationComment.vue?vue&type=template&id=6bddeca6&scoped=true&"
import script from "./NotificationCardForMandalaEvaluationComment.vue?vue&type=script&lang=js&"
export * from "./NotificationCardForMandalaEvaluationComment.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCardForMandalaEvaluationComment.vue?vue&type=style&index=0&id=6bddeca6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bddeca6",
  null
  
)

export default component.exports